<template>
  <div id="app">
      <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
    name:'App',
    provide(){
        return {
            reload: this.reload
        }
    },
    data(){
        return{
            isRouterAlive:true
        }
    },
    methods: {

        reload(){
            this.isRouterAlive = false
            this.$nextTick(function(){
                this.isRouterAlive = true
            })
        },

    },
    watch: { // watch的第二种写法
      $route: {
        handler (to, from){
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0


        },
        // 深度观察监听
        deep: true
      }
    },
    mounted() {

    }
}
</script>

<style lang="less">
//el-image
.el-image-viewer__close{
  top: 80px!important;
}
.el-image-viewer__mask{
  opacity: 0.9!important;
}

.card_m{
    li p,span{
        font-size:16px;
    }
}
.switch_box{
    li p,span{
        font-size:16px;
    }
}
*{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body, h1, h2, h3, h4, h5, h6, dl, dt, dd, ul, li, img, input, select, p, em, i, a {
    padding: 0;
    margin: 0;
    list-style: none;
    font-style: normal;
    outline: none;
    /*-webkit-user-select: none;*/
    /*-moz-user-select: none;*/
    /*-ms-user-select: none;*/
    /*user-select: none;*/
    text-decoration: none;
    /*//color: inherit;*/
    /*font-weight: normal;*/
    /*font-size: 16px;*/
    cursor:default;
}
body,html,#app{
  width: 100%;
  height: 100%;
  font-size: 16px;
  background: #F7F8F8;
  margin: 0;
  //overflow-y: auto;
}
html,body{
  overflow-y: auto!important;
}
&::-webkit-scrollbar {
//  display: none;
  //z-index: 999;
}

body{
  min-width: 1200px;
  font-family: 'SourceHanSansCN-Medium';
  display: block;
  margin: 0;
}
img{
    vertical-align: top;
}
.main{
    width: 100%;
    height: auto;
    position: absolute;
    margin: 0;
}
.fr{
    float: right;
}
.mb-30{
    margin-bottom: 30px;
}

.clearfix:before, .clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}
.clearfix {
  *zoom: 1; /*IE/7/6*/
}


/*全局css---------------------------------------------*/
.flex_lr{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.flex_c{
    display: flex;
    justify-content: center;
    align-items: center;
}
.flex_t{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}
.flex_r{
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
}
.flex_lr_t{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.flex_l_r{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
}
.table_b{
    border: none;
    border-collapse: collapse;
    width: 100%;
    border-spacing: 0;
    td {
        border: 1px solid #DCDFE6;
        padding: 8px 5px!important;
        text-align: center;
    }
}
.el-submenu .el-menu-item{
  min-width: auto!important;
}
.overflow_1{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.overflow_2{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.overflow_3{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
.overflow_4{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.el-aside{
    background-color: rgba(44, 103, 159, 1);
    .el-icon-arrow-down:before{
        color: #fff;
    }
    .el-menu{
        border-right: none;
    }

    &::-webkit-scrollbar {
        width: 4px;
        height: 100%;
        background: rgb(6, 88, 165);
    }
    /*定义滚动条轨道*/
    &::-webkit-scrollbar-track {
        border-radius: 2px;
    }
    /*定义滑块*/
    &::-webkit-scrollbar-thumb {
        border-radius: 0;
        background: #034786FF;
    }
}

.el-dialog__footer{
    text-align: center;
}
.detail_h5{
    font-size: 18px;
    font-weight: normal;
    line-height: 30px;
    margin-bottom: 5px;
    color: #07aaf0;
}

.main_center{
    padding: 0.7% 0.7% 30px!important;
}
.el-divider{
    color: #666;
    background-color: #999;
}



//前端页面------------------------------------------------------
.ym{
    width: 1200px;
    margin: 0 auto;
    position: relative;
}

.content,.content_h{
  min-height: 600px;
}
.imgcu_i{
  font-size: 14px;
  color: #999;
}

.con_detail{
  img{
    max-width: 100%;
  }
  p{
    img{
      width: 100%;
      height: auto;
      display: block;
    }
  }
}

.content{
    width: 100%;
    padding: 60px 0 100px;
    font-family: SourceHanSansCN;
    .cm{
      padding: 22px;
      box-sizing: border-box;
      background: #fff;
    }
    p{
      img{
        max-width:100%;
      }
    }
}

.img_fit{
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.obanner{
  width: 100%;
  padding-top: 70px;
  position: relative;
  div{
    width: 100%;
    height: 286px;
  }
  h5{
    font-size: 68px;
    color: #FFFEFE;
    line-height: 100px;
    text-align: center;
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 100px;
    transform: translateY(-50%+36px);
    z-index: 333;
    letter-spacing: 4px;
 //   font-weight: normal;
  }
}


//新闻--------------------------------
.news_ul{
  li{
    padding: 28px 0;
    border-bottom: 1px solid #C9CACA;
    transition: all 0.4s;
    &:hover{
      background: #F0EEEF;
      transform: scale(0.98);
    }

    .news_l{
      width: 376px;
      height: 240px;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .news_r{
      width: 63%;
      font-family: SourceHanSansCN;
      h6{
        font-size: 18px;
        font-weight: bold;
        color: #BA1E29;
        line-height: 30px;
        margin-bottom: 20px;
      }
      p{
        font-size: 14px;
        color: #898989;
        line-height: 30px;
        margin-bottom: 40px;
      }
      .time{
        font-size: 16px;
        margin-bottom: 0;
      }
      i{
        width: 12px;
        height: 12px;
        display: inline-block;
        background: url("assets/time.png") no-repeat;
        background-size: 100% 100%;
        margin-right: 12px;
      }
    }

  }
}

//后端页面------------------------------------------------------
.select_div{
  margin: 0 0 20px;
 .el-date-editor .el-range-separator{
    width: auto;
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 300px;
  }
  /deep/.el-select{
    width: 150px;
    margin-right: 15px;
  }
  .el-input{
    width: 220px;
    margin-right: 15px;
  }
  .el-button{
    background: #1E4886!important;
    color:#fff!important;
    border-radius: 4px;
  }

  .blue-button {
    background: #1E4886;color:#fff;
    border-radius: 4px;
  }
}

.crums_d{
  background: #F7F8F8;
}
.adm{
  //height: calc(100vh - 144px);
  min-height: calc(100% - 40px);
  //height: 100%;
  background: #fff;
  border-radius: 20px;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 10px;
}



</style>
